// File: /js/pages/content-create.js

import { setupDynamicBlocks }     from '../shared/extensions/dynamicBlocks-create.js';
import { setupReferenceBlocks }   from '../shared/extensions/reference-create.js';
import { setupKeywordBlocks }     from '../shared/extensions/keywords-create.js';
import { setupQuestionManagers }  from '../shared/extensions/questionManager-create.js';
import { setupDeckImport }        from '../shared/extensions/deckImport-create.js';
import '../shared/extensions/socialCards-create.js';
import { reinitializePodcastEmbeds } from '../shared/utils/podcastUtils.js';

import {
  setupGlobalRichtextPasting,
  enableRichtextKeyboardShortcuts,
  trackRichtextSelection,
  enableGlobalRichtextToolbarClicks,
  enableRichtextFontSizeBoxes,
  enableRichtextListMenus,
  enableRichtextLinkMenus
} from '../shared/utils/richtextUtils.js';

export function setupAll() {
  // ---------------------------------------------------------------------------
  // Global richtext behaviors (ONE place, applies to dynamic blocks + quiz answers
  // + any future contenteditable .richtext fields, including dynamically inserted).
  // All are idempotent (safe if called multiple times).
  // ---------------------------------------------------------------------------
  setupGlobalRichtextPasting();
  enableRichtextKeyboardShortcuts();
  trackRichtextSelection();            // internal per-editor range tracking
  enableGlobalRichtextToolbarClicks(); // delegated toolbar clicks (B/I/U)
  enableRichtextFontSizeBoxes();       // delegated numeric font-size box (▴▾)
  enableRichtextListMenus();           // delegated bullet/numbered list dropdown
  enableRichtextLinkMenus();           // delegated link popover (🔗 button)

  // ---------------------------------------------------------------------------
  // Page-specific feature wiring
  // ---------------------------------------------------------------------------
  setupDynamicBlocks();
  setupReferenceBlocks();
  setupKeywordBlocks();
  setupQuestionManagers();             // one wiring serves contest + quiz_challenge creator managers
  setupDeckImport();                   // contest-only "Importer un deck" control (no-op elsewhere)
  reinitializePodcastEmbeds();         // 🔁 ensure podcast previews render from PHP
}

// Auto-run if directly loaded on page
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupAll);
} else {
  setupAll();
}
